import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

class CheckoutThankYou extends Component {
  render() {
    const { order, cart, cartTotal, event, personal, settings, giftingOption, loading } = this.props;

    let gtagEcommerce;
    if (settings.helmet_google_analytics_id) {
      gtagEcommerce = {
        send_to: settings.helmet_google_analytics_id,
        transaction_id: order.id,
        value: cartTotal,
        currency: settings.currency,
        items: []
      };
      cart.forEach(cartItem => {
        if (cartItem.qty > 0) {
          gtagEcommerce.items.push({
            name: cartItem.tickets + ' for $' + cartItem.cost,
            quantity: cartItem.qty,
            price: cartItem.cost
          });
        }
      });
    }
    
    let gtagConversion;
    if (settings.helmet_google_gtag_conversion) {
      gtagConversion = JSON.parse(settings.helmet_google_gtag_conversion);
      if (gtagConversion && gtagConversion.json) {
        gtagConversion.json.value = cartTotal
        gtagConversion.json.transaction_id = order.id
        gtagConversion.json.currency = settings.currency
      }
    }
    
    if (!order){ return ('Processing...'); }
    if (loading){ return ('Loading...'); }

    if (order.orderstatus === 0 || order.orderstatus === 2) { // Order in progress || Order processed and tickets being generated
      return (<form className="w-full md:w-2/3">
        <h2 className="mb-6">Thank You</h2>
        <p className="leading-normal mb-6">Your order has been placed.</p>
        <p className="leading-normal mb-6">Once your order has been processed an email confirmation will be sent to you at{" "}
          <span className="font-bold  text-accent">{personal.email}</span>{" "}with your ticket numbers and confirmation number. If you have additional questions or concerns, please{" "}
          <Link to="/contact" className=" thankYouPageLink no-underline text-accent">contact us</Link> and include your confirmation number.{" "}
        </p>
        <p className="leading-normal mb-6">Thank you, <br />{event.nonprofit.name}</p>
        <p className="leading-normal"><Link to="/" className=" thankYouPageLink no-underline text-accent ">Back to homepage</Link></p>
      </form>);
    } else if (order.orderstatus === 1) { // Sale completed
      return (
        <div>
          <Helmet>
            {settings.helmet_google_gtag_conversion && gtagConversion && <script>{`gtag('` + gtagConversion.event + `', '` + gtagConversion.conversion + `',` + JSON.stringify(gtagConversion.json) + `);`}</script>}
            {settings.helmet_google_analytics_id && gtagEcommerce && <script>{`gtag('event', 'purchase',` + JSON.stringify(gtagEcommerce) + `);`}</script>}
            {settings.helmet_fbq_purchase_property_key && <script>{`fbq('track', '` + settings.helmet_fbq_purchase_property_key + `', {currency: "` + settings.currency + `", value: ` + cartTotal + `});`}</script>}
            {settings.scripts_sales_confirmation && <script>{settings.scripts_sales_confirmation}</script>}
          </Helmet>
          <form className="w-full md:w-2/3">
            <h2 className="mb-6">Thank You</h2>
            <p className="leading-normal mb-6">Thank you for purchasing tickets for the raffle{" "}<span className="font-bold text-accent">{event.title}</span>. For future reference, your order confirmation number is{" "}
            <span className="font-bold text-accent">{order.id}</span>.
          </p>
            <p className="leading-normal">An email confirmation has also been sent to{" "}
              {+giftingOption > 0 && personal.recipientList.length > 0 &&
                <span>
                  {personal.recipientList.map((key, value) =>
                    personal.recipientList[value]['recipientListFirstName'] !== "" &&
                    personal.recipientList[value]['recipientListEmail'] + ", "
                  )}and to{" "}
                </span>
              }you at{" "}
              <span className="font-bold text-accent">{personal.email}</span>{" "}with your ticket numbers and confirmation number. If the email has not been received within 2 hours, check your email spam folder just in case the email was misdirected. If you would like to also print your tickets now just click the button below.
            </p>
            <Link to={`/print-tickets?orderId=${order.id}&hash=${order.hash}`}
              className="inline-block no-underline bg-accent hover:bg-accent-dark text-accent-contrast font-bold py-3 px-6 rounded my-4"
              target="_blank">VIEW YOUR TICKETS
            </Link>
            <p className="leading-normal mb-6">If you have additional questions or concerns, please{" "}
              <Link to="/contact" className=" thankYouPageLink no-underline text-accent">contact us</Link> and include your confirmation number.{" "}
            </p>
            <p className="leading-normal mb-6">Thank you, <br />{event.nonprofit.name}</p>
            <p className="leading-normal"><Link to="/" className=" thankYouPageLink no-underline text-accent ">Back to homepage</Link></p>
          </form>
        </div>
      );
    } else if (order.orderstatus === 7) { // Process error
      return (
        <div>
          <h2 className="mb-6">Error: Could not process payment</h2>
          <p className="leading-normal mb-6">
            { order.error || "This could be due to incorrect CVV provided upon checkout. Please try again, "}
            <Link to="/" style={{ color: "inherit" }}>
              <span>homepage</span>
            </Link>
          </p>
        </div>
      );
    } else if (order.orderstatus === 8) { // Voided
      return (
        <div>
          <h2 className="mb-6">This ticket has been voided.</h2>
          <p className="leading-normal mb-6">
            If this is in error please contact support for assistance.
            <br/>
            <br/>Event : {event.title} - {event.id}, {event.date}
            <br/>Order confirmation number : {order.id}
          </p>
        </div>
      );
    } else if (order.orderstatus === 6) { // Not completed (sales ended, limit reached, etc)
      return (
        <div>
          <h2 className="mb-6">Warning: Order not completed</h2>
          <p className="leading-normal mb-6">
            <span>Please try again,  </span>
            <Link to="/" style={{ color: "inherit" }}>
              <span>homepage.</span>
            </Link>
          </p>
          <p className="leading-normal mb-6">
            If this issue persists then sales may be over, contact support for more info.
          </p>
        </div>
      );
    } else { // order has an unhandled status
      return (
        <div>
          <h2 className="mb-6">This order has an unrecognized status, please contact support for more info.</h2>
          <p className="leading-normal mb-6">
            Event : {event.title} - {event.id}, {event.date}
            <br/>Order confirmation number : {order.id}
            <br/>Order status id : {order.orderstatus}
          </p>
        </div>
      );
    } 
  }
}

export default CheckoutThankYou;
